import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';

/** Where the palette panel should render, captured from the header search
 * input at open time. Null = centered dialog (⌘K, mobile search icon). */
export interface PaletteAnchorRect {
  top: number;
  left: number;
  right: number;
  width: number;
}

interface CommandPaletteState {
  isOpen: boolean;
  anchorRect: PaletteAnchorRect | null;
  open: (anchorRect?: PaletteAnchorRect) => void;
  close: () => void;
  toggle: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>()(
  conditionalDevtools(
    (set) => ({
      isOpen: false,
      anchorRect: null,
      open: (anchorRect) => set({ isOpen: true, anchorRect: anchorRect ?? null }),
      close: () => set({ isOpen: false, anchorRect: null }),
      toggle: () =>
        set((state) => ({ isOpen: !state.isOpen, anchorRect: null })),
    }),
    { name: 'CommandPaletteStore' }
  )
);
